angular.module('unergie.main')
.controller('salesTunnelGasCtrl', (DynamicScriptLoaderService) => {
    DynamicScriptLoaderService.load('commons/salesTunnelGas.js')
})
